import { ref } from 'vue'

const showCreateModal = ref(false)

export const useCreateWorkspaceModal = () => {
  return {
    showCreateModal,
    openModal: () => {
      showCreateModal.value = true
    },
    closeModal: () => {
      showCreateModal.value = false
    },
  }
}
